import React, { Component } from 'react'
import { connect } from "react-redux";
import { noPayrollActivityAction } from '../../store/actions';
import Grid from '../../components/grid';
import { RangesForSelect } from '../../utils/date-ranges';
import { format, subDays } from 'date-fns';
import Axios from "axios";
import Loader from "../../components/loader";
import 'bootstrap-daterangepicker/daterangepicker.css';
import ReportDateRange from '../../components/reportDateRange';

export class NoPayrollActivityView extends Component {

    state = {
        loading: false,
        rowData: [],
        selectedRange: {},
        customDate: true,
        startDate: subDays(new Date(), 90),
        endDate: new Date(),
    };

    columnDefs = [
        {
            headerName: "Short Name",
            field: "companyShortName",
            sortable: true,
            filter: 'agMultiColumnFilter',
            resizable: true,
            width: "auto",
            rowGroup: true,
            hide: true,
            floatingFilter: true
        },
        {
            headerName: "Company Name",
            field: "companyName",
            sortable: true,
            filter: 'agMultiColumnFilter',
            resizable: true,
            width: "auto",
            floatingFilter: true
        },
        {
            headerName: "Start Date",
            field: "companyStartDate",
            sortable: true,
            filter: 'agDateColumnFilter',
            resizable: true, width: "auto",
            floatingFilter: true
        },
        {
            headerName: "CSR",
            field: "CSRAccount", sortable: true,
            resizable: true,
            filter: 'agMultiColumnFilter',
            width: "auto",
            floatingFilter: true
        },
        {
            headerName: "EIN Name",
            field: "payrollEINName",
            sortable: true, resizable: true,
            filter: 'agMultiColumnFilter',
            width: "auto",
            floatingFilter: true
        },
        {
            headerName: "Payrolls in Range",
            field: "recentPayrolls",
            sortable: true, resizable: true,
            filter: 'agNumberColumnFilter', width: "auto",
            floatingFilter: true
        },
        {
            headerName: "Last Payroll (12 Months)",
            field: "lastPayroll",
            sortable: true,
            filter: 'agDateColumnFilter',
            resizable: true, flex: 1, width: "auto",
            floatingFilter: true
        },
        {
            headerName: "Has Later Payrolls",
            field: "hasLaterPayrolls",
            sortable: true,
            filter: 'true',
            resizable: true, flex: 1, width: "auto",
            floatingFilter: true
        },

    ];

    handleEnter = (event) => {
        if (event.key.toLowerCase() === "enter") {
            const form = event.target.form;
            const index = [...form].indexOf(event.target);
            form.elements[index + 1].focus();
            event.preventDefault();
        }
    };

    async componentDidMount() {
        this.setState({ predefinedRanges: RangesForSelect, selectedRange: RangesForSelect[0].options[0] });
        await this.loadingData();
    }

    handleDateRange = (start, end) => {
        this.setState({ selectedRange: RangesForSelect[0].options[0] });
        this.state.startDate = new Date(start);
        this.state.endDate = new Date(end);
        this.setState({ customCaret: false, overlayBox: false });
    }

    loadingData = async () => {
        this.setState({ loading: true, });
        let records = await Axios.get('api/active-payroll/active-clients-report', {
            params:
                { startDate: this.state.startDate, endDate: this.state.endDate }
        });
        this.setState({ loading: false, rowData: records.data || [] });
    };

    onChangeSelected = (selected) => {
        if (selected.group === "Custom") {
            this.setState({
                customDate: true,
                selectedRange: selected
            });
        } else {
            this.setState({
                customDate: false,
                startDate: new Date(selected.from),
                endDate: new Date(selected.to),
                selectedRange: selected
            });
        }
        if (selected.to && selected.from) {
            //this.loadingData();
        };
    };

    showDateRange = () => {
        this.setState({
            customDate: true,
        });
    };

    ShowOverlayBox = () => {
        this.setState({ overlayBox: true });
    };
    hideCustomCaret = () => {
        this.setState({ overlayBox: false });
    };


    render() {
        const { loading, rowData, predefinedRanges, selectedRange, customDate } = this.state;
        return (
            <>
                <div className="table-header d-flex align-items-center justify-content-between">
                    <h3 className="heading_h3"> No Payroll Activity</h3>
                </div>

                <div className="shadow_white_box full-box mt-0">
                    <div className="filter-list d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center justify-content-between">
                        </ div>
                        <div className="d-flex align-items-center justify-content-between">

                            <ReportDateRange
                                startDate={this.state.startDate}
                                endDate={this.state.endDate}
                                handleSelect={this.onChangeSelected}
                                handleDateRange={this.handleDateRange}
                                style={{
                                    container: {
                                        padding: '5px',
                                    }
                                }}
                            >
                            </ReportDateRange>
                            <div className="flex-box mr-10">
                                <button className="mla fs12 primary mini" onClick={this.loadingData} disabled={loading}>
                                    <span>Run</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    {!loading ? <div className='loading-data'>
                        <Grid
                            columnDefs={this.columnDefs}
                            groupDisplayType='groupRows'
                            rowData={rowData}
                            groupDefaultExpanded={1}
                            height='600px'
                            loading={false}                        >
                        </Grid>
                    </div> : <div className='loading-data d-flex align-items-center justify-content-center'> <Loader></Loader> </div>}

                </div>
            </>
        )
    }
}
const mapStateToProps = ({ UserReducer, }) => ({ UserReducer, });

export default connect(mapStateToProps, { noPayrollActivityAction })(NoPayrollActivityView);
